import { truncate } from '@/utils/string'

export default truncate
